export const SHOP_POLICIES_QUERY = `
query getShopDetails{
  shop {
		refundPolicy{ title body handle }
		privacyPolicy{ title body handle }
		termsOfService{ title body handle }
		}
}`;
